
























































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import store from 'src/assets/store'
import { default as ItemDataLive, ItemDataUpdate } from 'src/assets/ItemDataLive'
import { AttendeeItemData, AttendeeResponseResult } from 'src/assets/AttendeeItemData'
import PersonAvatar from 'components/account/PersonAvatar.vue'
import DeadlineTimerCountdown from 'components/DeadlineTimerCountdown.vue'
import TimerDisplay from 'components/TimerDisplay.vue'
import SessionChat from 'components/attendee/session/SessionChat.vue'
import SessionInfo from 'components/attendee/session/SessionInfo.vue'
import SlidesViewer from 'components/attendee/session/SlidesViewer.vue'
import AttendeeResponse from 'components/presenter/item/session/AttendeeResponse.vue'
import api from 'src/assets/api/gql'
import Subscription from 'src/assets/api/Subscription'
import AttendeeResponseSubscription from 'src/graphql/attendee/AttendeeResponseSubscription.gql'
import AttendeeSessionSubscription from 'src/graphql/attendee/AttendeeSessionSubscription.gql'
import AttendeeTopicSubscription from 'src/graphql/attendee/AttendeeTopicSubscription.gql'
import AttendeeUpdateResponseStart from 'src/graphql/attendee/AttendeeUpdateResponseStart.gql'
import { Session, SessionAttendee, Item, ItemTypeTopic } from 'src/graphql/types'

@Component({
  components: {
    PersonAvatar,
    DeadlineTimerCountdown,
    TimerDisplay,
    SessionChat,
    SessionInfo,
    SlidesViewer,
    AttendeeResponse
  }
})
export default class PageAttendeeSession extends Vue {
  ItemTypeTopic = ItemTypeTopic
  store = store
  top = true
  rightDrawerShowing = false
  attendeeResponseResult: AttendeeResponseResult | null = null
  topicSubscription!: Subscription
  sessionSubscription!: Subscription
  attendeeSubscription!: Subscription

  @Prop()
  readonly attendee!: SessionAttendee

  get session () {
    return this.attendee.responseSession || { data: {} } as Session
  }

  get topic () {
    return this.attendee.responseTopic || { data: {} } as Item
  }

  get isSessionStarted () {
    return this.session && this.session.startedAt && (new Date(this.session.startedAt) < store.now())
  }

  get isSessionOver () {
    return this.session && this.session.stoppedAt && (new Date(this.session.stoppedAt) < store.now())
  }

  get showResults () {
    return this.session?.data?.result && (this.topic.typeTopic === ItemTypeTopic.Keynote ? this.isSessionOver : this.attendee?.finishedAt)
  }

  @Watch('topic.data', { deep: true })
  topicChangeUpdateResults () {
    this.updateResults(this.topic, this.attendee)
  }

  @Watch('attendee.data', { deep: true })
  responseChangeUpdateResults () {
    this.updateResults(this.topic, this.attendee)
  }

  created () {
    this.topicSubscribe(this.attendee, this.topic)
    this.sessionSubscribe(this.attendee, this.session)
    this.attendeeSubscribe(this.attendee)
  }

  beforeDestroy () {
    this.topicSubscription?.end()
    this.sessionSubscription?.end()
    this.attendeeSubscription?.end()
  }

  updateResults (topic: Item, attendee: SessionAttendee) {
    const attendeeItemData = new AttendeeItemData(topic.typeTopic as ItemTypeTopic, topic.data as ItemDataLive, attendee)
    this.attendeeResponseResult = new AttendeeResponseResult(attendeeItemData)
  }

  attendeeSubscribe (attendee: SessionAttendee) {
    this.attendeeSubscription = new Subscription(AttendeeResponseSubscription, { attendeeId: attendee.id })
    this.attendeeSubscription.start((data: any) => {
      const init = data?.attendeeResponse?.init || {}
      Object.assign(attendee, init as SessionAttendee)
      const payload = data?.attendeeResponse?.payload?.data || {}
      if (payload.data) {
        payload.data = attendee.data = Object.assign({}, attendee.data, payload.data)
      }
      Object.assign(attendee, payload as SessionAttendee)
    })
  }

  sessionSubscribe (attendee: SessionAttendee, session: Session) {
    this.sessionSubscription = new Subscription(AttendeeSessionSubscription, { attendeeId: attendee.id })
    this.sessionSubscription.start((data: any) => {
      const init = data?.attendeeSession?.init || {}
      Object.assign(session, init as Session)
      const payload = data?.attendeeSession?.payload?.data || {}
      if (payload.data) {
        payload.data = session.data = Object.assign({}, session.data, payload.data)
      }
      Object.assign(session, payload as Session)
    })
  }

  topicSubscribe (attendee: SessionAttendee, topic: Item) {
    this.topicSubscription = new Subscription(AttendeeTopicSubscription, { attendeeId: attendee.id })
    topic.data = new ItemDataLive(topic.id, this.topicSubscription)
    this.topicSubscription.start((data: any) => {
      const init = data?.attendeeTopic?.init
      if (init) {
        topic.data?.update(init.data || {})
      }
      const payload = data?.attendeeTopic?.payload
      if (payload) {
        topic.data?.update(payload.data || {})
      }
    })
  }

  async startResponse () {
    await api.mutate({
      query: AttendeeUpdateResponseStart,
      variables: { attendeeId: this.attendee.id }
    })
  }

  exit () {
    this.$emit('exit')
  }
}
